import Cookies from 'js-cookie';
import { PageType } from './gamecloud/interface';
import { initAdminbar } from './adminbar/adminbar';
import { initSearch } from './navigation/search';
import { Company } from '../vue/plugins/configuration/types/configuration';
import { publish } from '../shared/eventbus/eventbus';
import { Events } from '../shared/eventbus/events';
import { lazyLoading } from '../vue/helper/lazyLoading.js';
import { initRef } from './ref/ref';

if (process.env.NODE_ENV !== 'production') {
  console.log('Looks like we are in development mode!');
} else {
  console.log('Looks like we are in production mode!');
}

/* for the google tag manager */
window.dataLayer = window.dataLayer || [];

export const trackGTM = (event: string, data: any) => {
  window.dataLayer.push({
    event,
    data,
  });
};

declare global {
  interface Window {
    $: JQuery;
    jQuery: JQuery;
    debug: boolean;
    basePath: string;
    nonLocalizedSelfUrl: string;
    regionPrefix: string;
    localePrefix: string;
    urlLanguage: string;
    ajaxPath: string;
    redirectSeconds: number;
    vueControllerBaseUrl: string;

    fetchServersForMenu: boolean;
    menuUrl: string;

    /* check if the user is logged in */
    login_user: any;

    /* User Locale for Language */
    customerLanguageCode: string;
    customerCurrencyCode: string;

    /* for pageTypes beeing write into the head */
    pageType: PageType;

    /* google tag manager */
    dataLayer?: object[];
    googleRecaptchaKey: string;

    /* svg icons releated */
    cdnBaseUrl: string;

    company: Company;
  }
}

window.debug = process.env.NODE_ENV !== 'production';

initSearch();
initAdminbar();
initRef();

$(document).on('click', '[data-open-recharge-modal]', () => {
  console.log('open recharge modal');
  publish(Events.OpenRechargeModal, {});
});

/* Remember the clients local timezone */
const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
if (clientTimeZone !== undefined) {
  Cookies.set(
    window.cookieTimezoneName,
    clientTimeZone,
    {
      path: window.cookiePath,
      domain: window.cookieDomain,
      expires: 365,
      sameSite: 'Strict',
    },
  );
}
